import {Component, OnInit} from '@angular/core';
import {RequestManagerService} from '@services/request-manager/request-manager.service';
import {IUpload} from '@interfaces/iupload';
import {UserService} from '@services/user/user.service';
import {IUser} from '@interfaces/iuser';
import * as moment from 'moment';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-uploads',
  templateUrl: './uploads.component.html',
  styleUrls: ['./uploads.component.scss']
})
export class UploadsComponent implements OnInit {
  uploads: IUpload[];
  users: IUser[];
  params = {limit: 20, offset: 0};
  isLoading = true;
  displayedColumnsUploads: string[] =
    ['filename', 'description', 'contentAccepted', 'clearedForPayment', 'uploadedToDATEV', 'retry'];
  allUploadsLoaded = false;


  constructor(
    public userService: UserService,
    private requestManager: RequestManagerService,
    private snackBar: MatSnackBar,
  ) {
  }

  ngOnInit() {
    this.updateUploads();
  }

  loadMoreUploads() {
    this.params.offset += this.params.limit;
    this.requestManager.get('/adminArea/uploads', this.params)
      .then(res => {
        if (!res['departmentsFiles']) {
          this.allUploadsLoaded = true;
          this.snackBar.open('Es wurden alle Uploads geladen', 'Okay', {duration: 5000});
        }
        this.uploads = [...this.uploads, ...res['departmentsFiles']];
        this.writeUserToUpload();
      });
  }

  writeUserToUpload() {
    this.uploads.forEach(
      upload => {
        upload.contentAcceptedByUser = this.users.find(user => user.id == upload.contentAcceptedBy);
        upload.clearedForPaymentByUser = this.users.find(user => user.id == upload.clearedForPaymentBy);
        upload.uploadedByUser = this.users.find(user => user.id == upload.uploadedBy);

        upload.contentAcceptedByName = upload.contentAcceptedByUser ?
          `${upload.contentAcceptedByUser.name} ${upload.contentAcceptedByUser.surname}` : '';
        const contentDate = moment(upload.contentAcceptedDate).format('[am] DD.MM.YYYY [um] HH:mm');
        upload.contentAcceptedByName = `${upload.contentAcceptedByName} ${contentDate}`;

        upload.clearedForPaymentByName = upload.clearedForPaymentByUser ?
          `${upload.clearedForPaymentByUser.name} ${upload.clearedForPaymentByUser.surname}` : '';
        const paymentDate = moment(upload.clearedForPaymentDate).format('[am] DD.MM.YYYY [um] HH:mm');
        upload.clearedForPaymentByName = `${upload.clearedForPaymentByName} ${paymentDate}`;
        upload.uploadedByName = upload.uploadedByUser ?
          `${upload.uploadedByUser.name} ${upload.uploadedByUser.surname}` : '';
      }
    );
  }

  async retryFileUpload(element: any) {
    await this.requestManager.put('/departmentsFiles/' + element.id, {uploadedToDATEV: 'NULL', error: 'NULL'});
    this.snackBar.open('Der Beleg wurde nochmals in den Upload eingereiht!', undefined, {duration: 2000});
    this.updateUploads();
  }

  private updateUploads() {

    this.isLoading = true;
    Promise.all([
      this.requestManager.get('/adminArea/uploads', this.params),
      this.userService.getUserList()
    ])
      .then(([uploads, users]) => {
        this.uploads = uploads['departmentsFiles'];
        this.users = users['user'];
        this.writeUserToUpload();
      });
    this.isLoading = false;
  }
}
